// extracted by mini-css-extract-plugin
export default {"product-grid":"fao6-n19ibPRqRKW920EHw==","error-text":"BWRT4D2SCgb5Wtyjhutcwg=="};